{
  "version": 1,
  "asset_id": "28ea59f5-3f48-47fe-8537-adcbb4b4bdb5",
  "project_id": "a3729fa2-e85b-4f5b-84b2-0934e880c580",
  "url": "/__l5e/assets-v1/28ea59f5-3f48-47fe-8537-adcbb4b4bdb5/palworld-online-garena-mobile-cover.webp",
  "r2_key": "a/v1/a3729fa2-e85b-4f5b-84b2-0934e880c580/28ea59f5-3f48-47fe-8537-adcbb4b4bdb5/palworld-online-garena-mobile-cover.webp",
  "original_filename": "palworld-online-garena-mobile-cover.webp",
  "size": 140802,
  "content_type": "image/webp",
  "created_at": "2026-09-23T14:49:48Z"
}
